import { FC } from 'react'
import { ChallengerBox } from '..'

import Style from './UserRank.module.scss'
interface Props {
    userData?: usersRequest
    performance?: performanceRequest
    seasonSummary?: boolean
    userInfo?: UserInformationT
}

export const UserRank: FC<Props> = ({
    userData,
    performance,
    seasonSummary,
    userInfo,
}) => {
    if (userInfo) {
        return (
            <div className={Style.container}>
                <ChallengerBox
                    tier={userInfo.rankingInfo.tier || ''}
                    highlighted
                    profileName={userInfo.userInfo.displayName}
                    score={userInfo.rankingInfo.pnl || ''}
                    rank={userInfo.rankingInfo.rank || ''}
                    performance={performance}
                    seasonSummary={seasonSummary}
                />
            </div>
        )
    }
    return (
        <div className={Style.container}>
            <ChallengerBox
                tier={userData?.tier?.name || ''}
                highlighted
                profileName={userData?.additional_user_info?.profileName}
                score={userData?.score || ''}
                rank={userData?.rank?.toString() || ''}
                performance={performance}
                seasonSummary={seasonSummary}
            />
        </div>
    )
}
